import React from "react";
import Link from "next/link";

import Meta from "../components/Meta";
import Faq from "../components/faq/faq";
import HeaderSection from "../components/header/HeaderSection";
import {pricing_faq_data} from "../data/pricing_faq_data";


const Page = () => {
  return (
    <>
      <Meta title="Join the Engineering Book Club and start learning NOW"/>
      <HeaderSection title="Join Now" subtitle="Join the Book Club and start learning NOW"/>
      <section className="py-5">
        <div className="container">

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 md:gap-[1.875rem] lg:grid-cols-2">
            <div className="dark:bg-jacarta-700 rounded-2lg dark:border-jacarta-600 border-jacarta-50 border bg-white p-8 text-center transition-shadow hover:shadow-lg">
              <h2 className="font-display text-jacarta-700 text-2xl dark:text-white pb-5">
                Member
              </h2>
              <h4 className="font-display text-jacarta-700 text-md dark:text-white">
                Free Forever
              </h4>
              <span className="text-jacarta-400 text-2xs font-medium tracking-tight">Become a Club Member and <br/>get access to the community</span>
              <div className="mt-3 flex justify-center space-x-5">
                <Link
                  href="https://discord.gg/pc2pqxwtHV"
                  className="w-36 rounded-full bg-accent py-3 px-8 text-center font-semibold text-white transition-all hover:bg-accent-dark">
                  
                    Join
                  
                </Link>
              </div>
            </div>

            <div className="dark:bg-jacarta-700 rounded-2lg dark:border-jacarta-600 border-jacarta-50 border bg-white p-8 text-center transition-shadow hover:shadow-lg">
              <h2 className="font-display text-jacarta-700 text-2xl dark:text-white pb-5">
                Pro Member
              </h2>
              <h4 className="font-display text-jacarta-700 text-md dark:text-white">
                From 5€ / month (billed annually)
              </h4>
              <span className="text-jacarta-400 text-2xs font-medium tracking-tight mb-10">Suited for everone who wants to enjoy <br/>the full experience and participate in live events.</span>

              <div className="mt-3 flex justify-center space-x-5">
                <Link
                  href="https://buy.stripe.com/cNieVf1Fg60f501aGzejK02"
                  className="w-36 rounded-full bg-accent py-3 px-8 text-center font-semibold text-white transition-all hover:bg-accent-dark">
                  
                    Join
                  
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <Faq faq_data={pricing_faq_data}/>
      </section>
    </>
  );
};

export default Page;
